module.exports = __webpack_public_path__ + "img/Fixit_timebestilling_logo.9874046.svg";